import { IModelEntity } from '@pit/core';
import { IDtoMandator } from './dto.mandator.interface';

export interface IDtoResourceAttribute extends IModelEntity {

    attributeType?: string;
    attributeKey?: string;
    attributeValue?: string;

    mandator?: IDtoMandator;

}
